import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

export default class BulkImport extends Component {
  state = {
    message: "",
    notification: false,
    redirect: false,
    allSubjects: [],
    alltopics: [],
    allLevels: [],
    level_id: "",
    topic_id: "",
    subject_id: "",
    search: "",
    questionsArray: "",
    loading: false,
  };

  componentDidMount() {
    this.getAllSubjects();
  }

  getAllSubjects = async () => {
    if (init() === "success") {
      const resp = await axios.get(
        `${Constants.getUrls.getAllSubjects}?search=${this.state.search}&limit=1000&page=1`
      );
      this.setState({
        allSubjects: resp?.data?.data?.docs || [],
      });
    }
  };

  handleTopic = async () => {
    if (init() === "success") {
      const resp = await axios.get(
        `${Constants.getUrls.getAllTopics}?subject_id=${this.state.subject_id}`
      );
      this.setState({
        alltopics: resp?.data?.data?.docs || [],
      });
    }
  };

  handleLevel = async () => {
    if (init() === "success") {
      const resp = await axios.get(
        `${Constants.getUrls.getAllLevels}?subject_id=${this.state.subject_id}&topic_id=${this.state.topic_id}`
      );
      this.setState({
        allLevels: resp?.data?.data?.docs || [],
      });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      subject_id: this.state.subject_id,
      level_id: this.state.level_id,
      topic_id: this.state.topic_id,
      questionsArray: this.state.questionsArray,
    };

    this.setState({ loading: true });

    try {
      const resp = await axios.post(Constants.postUrls.creatBulkImport, payload);
      this.setState({
        notification: true,
        message: resp.data.message,
        loading: false,
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "", redirect: true });
      }, 3000);
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Failed to import questions.",
        loading: false,
      });
      setTimeout(() => {
        this.setState({ notification: false, message: "" });
      }, 5000);
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/questions" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Bulk Import Questions
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container sm={12} spacing={2}>
                  <Grid item sm={6}>
                    <InputLabel>Select Subject</InputLabel>
                    <Select
                      value={this.state.subject_id}
                      onChange={(e) =>
                        this.setState({ subject_id: e.target.value }, () => this.handleTopic())
                      }
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select Subject</MenuItem>
                      {this.state.allSubjects.map((item) => (
                        <MenuItem value={item._id} key={item._id}>
                          {item.subject_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Select Topic</InputLabel>
                    <Select
                      value={this.state.topic_id}
                      onChange={(e) =>
                        this.setState({ topic_id: e.target.value }, () => this.handleLevel())
                      }
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select Topic</MenuItem>
                      {this.state.alltopics.map((item) => (
                        <MenuItem value={item._id} key={item._id}>
                          {item.topic_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Select Level</InputLabel>
                    <Select
                      value={this.state.level_id}
                      onChange={(e) => this.setState({ level_id: e.target.value })}
                      required
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="">Select Level</MenuItem>
                      {this.state.allLevels.map((item) => (
                        <MenuItem value={item._id} key={item._id}>
                          {item.level_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <InputLabel>Question JSON Array</InputLabel>
                    <TextField
                      multiline
                      minRows={10}
                      name="questionsArray"
                      value={this.state.questionsArray}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="AgriQuiz Questions"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
